<template>
<div>
  <v-card
    v-if="!pageloading"
    class="institution-card"
    :style="emptyCard ? 'background-color: #ff000017 !important;' : ''"
    outlined
  >
    <v-card-text >
      <!-- header  -->
      <v-row style="align-items: center">
        <v-col v-if="emptyCard" cols="12" class="pa-0">
          <v-progress-linear
            color="red"
            rounded
            :value="emptyCardProgress"
          ></v-progress-linear>
        </v-col>
        <v-btn icon @click="setShow">
          <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
        <v-col cols="6" md="6">
        <span v-html="cardTitle"></span>
        </v-col>
        <v-col cols="3" md="3" v-if="!show">
          <span>{{ getSelected }}</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click.native="removeServiceProvider()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <div class="tooltip-text">{{ $t('Šalinti') }}</div>
        </v-tooltip>
      </v-row>
      <v-expand-transition>
        <div v-show="show">
          <v-divider style="margin-top: 1rem"></v-divider>
          <v-col class="px-0" cols="12" md="12">
            <institution-services-card
              @isEmpty="isEmpty"
              @selected="selectedServices"
              @institutionData="setInstitutionData"
              :formData="formData"
              :institutionId="id"
              :addFilter="formData.action_providers[index].addFilter"
              :providerType="formData.action_providers[index].type"
              :customService="formData.action_providers[index].custom"
            ></institution-services-card>
          </v-col>
          <template v-if="showServicesList">
            <v-col class="pa-0 ma-0">
              <h3>{{ $t('Pasirinktos paslaugos') }}</h3>
            </v-col>
            <v-col
             class="pb-0 pt-2"
              v-for="item in formData.action_providers[index].services"
              :key="item.id"
              cols="12"
              md="12"
            >
              <services-card
                @removeServiceItem="removeServiceModal"
                :item="item"
                :index="index"
                light
                :providerType="formData.action_providers[index].type"
              ></services-card>
            </v-col>
          </template>
        </div>
      </v-expand-transition>
    </v-card-text>
  </v-card>
   <modal-delete
        title="Įrašo šalinimas"
        :text="modalDeleteText"
        v-model="showDeleteModal"
        :item="modalDeleteItem"
        @confirmDelete="confirmDelete"
      />
  </div>
</template>

<script>
import InstitutionServicesCard from './InstitutionServicesCard'
import ServicesCard from './ServicesCard'
import Enums from '@/enums'
import ModalDelete from '@/components/modals/ModalDelete'
import errorNotifications from '@/mixins/errorNotifications'

export default {
  name: 'InstitutionCard',
  components: {
    InstitutionServicesCard,
    ServicesCard,
    ModalDelete,
  },
  mixins: [errorNotifications],
  props: {
    index: [String, Number],
    formData: [Object, Boolean, String, Number],
    id: [String, Number],
  },
  data() {
    return {
      institutionData: {},
      pageloading: false,
      emptyCard: false,
      emptyCardProgress: null,
      services: [],
      showDeleteModal: false,
      modalDeleteItem: {},
      modalDeleteText: '',
    }
  },
  created() {
  },
  computed: {
    show(){
      if(this.formData.action_providers[this.index].show == null){
        this.$set(this.formData.action_providers[this.index], 'show', true)
      }
     return this.formData.action_providers[this.index].show
    },
    selected() {
      return this.formData.action_providers[this.index].services?.length || 0
    },
    showServicesList() {
      return this.formData.action_providers[this.index].services?.length > 0
    },
    elValue: {
      get() {
        return this.formData
      },
      set(elValue) {
        this.$emit('formData', elValue)
      },
    },
    getSelected() {
      let selectedText = ''
      if (this.selected == 0 || this.selected >= 10) {
        selectedText = `${this.$t('Pasirinkta:')} ${this.selected} ${this.$t('paslaugų')}`
      } else if (this.selected == 1) {
        selectedText = `${this.$t('Pasirinkta:')} ${this.selected} ${this.$t('paslauga')}`
      } else {
        selectedText = `${this.$t('Pasirinkta:')} ${this.selected} ${this.$t('paslaugos')}`
      }
      return selectedText
    },
    getTitle() {
      let title = ''
      let provider_type = this.formData.action_providers[this.index].type
      if (provider_type === 'amn') {
        if (this.formData.action_providers[this.index].custom) {
          title =
            this.formData.action_providers[this.index].institution.fullname
        } else {
          title = this.institutionData?.fullname || ''
        }
      } else {
        title = this.$t(Enums.providerType[provider_type])
      }
      return title
    },
    getOtherInfo() {
      return this.institutionData?.other_info
        ? `(${this.institutionData.other_info})`
        : ''
    },
    cardTitle() {
      return `<strong>${this.getTitle}</strong> ${this.getOtherInfo}`
    },
  },
  methods: {
    setShow(){
      let logic = !this.formData.action_providers[this.index].show
      this.$set(this.formData.action_providers[this.index], 'show', logic)
    },
    isEmpty(val) {
      if (val) {
        this.emptyCard = true
        var intervalHandle = null
        let time = 0
        var that = this
        intervalHandle = setInterval(function () {
          that.emptyCardProgress = time
          time++
          if (time >= 100) {
            clearInterval(intervalHandle)
            that.removeServiceProvider(true)
          }
        }, 100)
      }
    },
    confirmDelete(item){
      this.showDeleteModal = false;
      this.removeService(item.item)
    },
    removeServiceModal(item){

      this.modalDeleteText = this.notificationText('000018')
      this.showDeleteModal = true;
      this.modalDeleteItem = {item: item, type: 'service'};
    },
    // removeServiceChildrens(index, id, byID){
    //     this.formData.action_providers[index].services.map((item) => {
    //       if(byID){
    //         if(item.parent_id == id){
    //           this.removeServiceChildrens(index, item.id)
    //           let serviceIndex = this.formData.action_providers[index].services.findIndex(
    //           (servicIitem) => servicIitem.id === item.id
    //           )
    //           this.formData.action_providers[index].services.splice(serviceIndex, 1)
    //           }
    //       } else {
    //         if(item.parent_id == id){
    //           this.removeServiceChildrens(index, item.action_id)
    //           let serviceIndex = this.formData.action_providers[index].services.findIndex(
    //           (servicIitem) => servicIitem.action_id === item.action_id
    //           )
    //           this.formData.action_providers[index].services.splice(serviceIndex, 1)
    //         }
    //       }
    //     })
    // },
    removeService(item) {
      let index = this.formData.action_providers[
        item.index
      ].services.findIndex(
        (serviceIitem) => serviceIitem.action_id === item.action_id
      )
      if (index > -1) {
        // remove childrens
          // if(this.formData.action_providers[item.index].services[index].id){
          //   this.removeServiceChildrens(item.index, this.formData.action_providers[item.index].services[index].id, true)
          // } else {
          //   this.removeServiceChildrens(item.index, this.formData.action_providers[item.index].services[index].action_id, false)
          // }
          index = this.formData.action_providers[
          item.index
        ].services.findIndex(
          (serviceIitem) => serviceIitem.action_id === item.action_id
        )
          this.formData.action_providers[item.index].services.splice(index, 1)
      }

      this.$emit('serviceListUpdated')
    },
    formatNewItem(item) {
      let newItem = {}
      newItem.action_id = item.id
      newItem.parent_id = item.parent_id
      newItem.institution = item.institution
      newItem.title_lt = item.title_lt
      newItem.title_en = item.title_en
      newItem.default_description_editable = item.default_description_editable
      newItem.description = this.$i18n.locale === 'lt' ? item.default_description_lt : item.default_description_en
      newItem.pasis_code = item.pasis_code
      newItem.code = item.code
      newItem.signature_required = item.signature_required
      return newItem
    },
    selectedServices(services) {
      services.map((item) => {
        if (this.showServicesList) {
          const index = this.formData.action_providers[
            this.index
          ].services.findIndex(
            (serviceItem) => serviceItem.action_id == item.id
          )
          if (index === -1) {
            let newItem = this.formatNewItem(item)
            this.formData.action_providers[this.index].services.unshift(newItem)
          }
        } else {
          let newItem = this.formatNewItem(item)
          this.formData.action_providers[this.index].services.unshift(newItem)
        }
      })

      this.$emit('serviceListUpdated')
    },
    removeServiceProvider(instant) {
      let providerType = this.formData.action_providers[this.index].type
      this.$emit('removeID', {id: this.id, providerType: providerType, instant: instant})
      this.$emit('serviceListUpdated')
    },
    setInstitutionData(institution) {
      this.institutionData = institution
      this.formData.action_providers[this.index].addedInstitutionData = institution
    },
  },
}
</script>

<style lang="scss" scoped></style>
